<template>

<core-modal v-on:close="onClose" :is-empty="!items.length" :nopadding="true">

	<template v-slot:head>

		{{ contextName }} Views

	</template>

	<template v-slot:default>

		<template v-for="item in items">

			<com-view :key="item.id" :item="item" />

		</template>

        <div class="manage-empty" v-if="!items.length">

            No views created.

        </div>

	</template>

	<template v-slot:foot>

		<core-button theme="blue" v-on:click.native="onCreateClick">Create View</core-button>

		<core-button theme="blue" v-on:click.native="onDefaultClick">Set Default</core-button>

	</template>

</core-modal>

</template>

<script>

import comView from './manage/View'

export default {

	props: ['data'],

	components: {
		comView
	},

	data: function() {

		return {

			is: {
				loading: false
			}

		}

	},

	computed: {

		contextName: function() {

			if (this.$currentViewContext === 'collection') return 'Collection'
			if (this.$currentViewContext === 'ratings') return 'Rating'
			if (this.$currentViewContext === 'plays') return 'Play'
			if (this.$currentViewContext === 'gameplays') return 'Game'

			return ''

		},

		items: function() {

			var items = []

			var context = 0

			if (this.$currentViewContext === 'collection') context = 1
			if (this.$currentViewContext === 'ratings') context = 2
			if (this.$currentViewContext === 'plays') context = 3
			if (this.$currentViewContext === 'gameplays') context = 4

			items = this.$_.sortBy(this.$store.getters['data/views/list'], function(item) {

				return item.name.toLowerCase()

			})

			items = this.$_.filter(items, function(item) {

				return item.context === context

			})

			return items

		}

	},

	methods: {

        onCreateClick: function() {

			this.$pubsub.$emit('open.modal', {
				id: 'viewsManageCreate',
				manage: true
			})	

        },

        onDefaultClick: function() {

			this.$pubsub.$emit('open.modal', {
				id: 'viewsManageDefault'
			})	

        },

		onClose: function() {

			this.$emit('close')

		}

	}

}

</script>

<style scoped>

.manage-empty {
    position: absolute;
    left: 0%;
    top: 50%;
    width: 100%;
    font-size: 20px;
    color: #fff;
    opacity: 0.75;
    font-weight: 400;
    text-align: center;
    line-height: 24px;
    padding: 16px;
}

</style>